import React from "react"

import { Wrapper, Text } from "./reactionsListHeaderStyles"

export const ReactionsListHeader = () => (
  <Wrapper>
    <Text>Reactions</Text>
  </Wrapper>
)
